module.exports = __webpack_public_path__ + "static/media/game-background-identify-sentence.06845fec.jpg";